// extracted by mini-css-extract-plugin
export var background = "bf_x";
export var container = "bf_b";
export var icon = "bf_bz";
export var input = "bf_cQ";
export var search = "bf_bX";